import React from 'react'
import TextImageBanner from '../../components/common/TextImageBanner'
import GalleryHero from '../../components/UserComponents/gallery/GalleryHero'
import image from "../../Assets/Home/MainHome/home3.png"
const Gallery = () => {
  return (
    <div className='bg-[#fafafa]'>
      <TextImageBanner label="Gallery"
        bgImage={[
          `${image}`,
          `${image}`,
          `${image}`,
        ]} />
      <GalleryHero />
    </div>
  )
}

export default Gallery